import { useLocation, useParams } from 'react-router-dom';

/**
 * Base path of the splat route that rendered the caller — the current pathname with the
 * splat remainder removed.
 *
 * react-router 7 resolves relative targets against the leaf match's full pathname
 * (v7_relativeSplatPath), so `navigate('audience')` from a component mounted on
 * `edit/:id/*` appends a segment instead of replacing the current one. Building an
 * absolute target from this base is exact under both 6 and 7. PLA-9372.
 */
export const splatBasePath = (pathname: string, splat?: string): string => {
  const base = splat ? pathname.slice(0, pathname.length - splat.length) : pathname;
  // No trailing slash: callers append `/${step}`, and a "/" base would build "//step",
  // which the browser reads as protocol-relative and treats as an external navigation.
  return base.replace(/\/+$/, '');
};

/**
 * Base path of the splat route rendering this component. Call from a component that is
 * the `element` of a `path="…/*"` route; it is variant-agnostic, so the maker-checker
 * routes (`edit/:id/campaign_request/:rid/*`) resolve without special-casing.
 */
export const useSplatBasePath = (): string => {
  const { pathname } = useLocation();
  const params = useParams();
  return splatBasePath(pathname, params['*']);
};
